// extracted by mini-css-extract-plugin
export var actions = "Productgrid-module--actions--82af2";
export var close = "Productgrid-module--close--7cb68";
export var col_1 = "Productgrid-module--col_1--17861";
export var col_2 = "Productgrid-module--col_2--0249c";
export var content = "Productgrid-module--content--d0454";
export var fadeSectionOne = "Productgrid-module--fadeSectionOne--ed8f5";
export var modal = "Productgrid-module--modal--64750";
export var pop_des = "Productgrid-module--pop_des--08f50";
export var pop_title = "Productgrid-module--pop_title--914c8";
export var products_section = "Productgrid-module--products_section--a7731";
export var reccomendedProduct = "Productgrid-module--reccomendedProduct--eb72b";
export var reccomendedasset = "Productgrid-module--reccomendedasset--d4854";